// Which API host to call is decided at RUNTIME, in the browser, based on
// the hostname that loaded this page - not baked in at build time via
// REACT_APP_API_DOMAIN. That build-time approach kept failing in practice
// (the build pipeline wasn't reliably picking the env var up), so this
// sidesteps it entirely: whatever hostname the browser is actually on
// decides the API host, every time the page loads, regardless of which
// build/deploy path was used to get this file live.
const hostname = window.location.hostname;

let API_DOMAIN;
if (hostname === "admin-staging.firmconnector.com") {
  API_DOMAIN = "staging-api.firmconnector.com";
} else if (
  hostname === "admin.firmconnector.com" ||
  hostname === "www.admin.firmconnector.com"
) {
  API_DOMAIN = "admin-api.firmconnector.com";
} else if (hostname === "localhost" || hostname === "127.0.0.1") {
  // Local dev - defaults to production API. Change this line if you'd
  // rather local dev hit staging instead.
  API_DOMAIN = "api.firmconnector.com";
} else {
  // Any other/unrecognized hostname - safe fallback to production, same
  // reasoning as before: visibly wrong (prod) beats silently wrong
  // (pointed at a backend nobody intended).
  API_DOMAIN = "api.firmconnector.com";
}

// Always visible in the browser console (nothing sensitive - it's just the
// hostname this page decided to call) so a page pointed at the wrong
// backend is obvious in 5 seconds instead of requiring a Network-tab hunt.
// eslint-disable-next-line no-console
console.info(
  `[env] API_DOMAIN = ${API_DOMAIN} (resolved at runtime from page hostname: ${hostname})`,
);

const API_BASE = `https://${API_DOMAIN}/index.php/`;
const ASSETS_BASE = `https://${API_DOMAIN}/assets/`;
const PROFILE_IMG_BASE = `https://${API_DOMAIN}/`;
const FIRM_IMG_BASE = `https://${API_DOMAIN}/`;

export { API_BASE, ASSETS_BASE, PROFILE_IMG_BASE, FIRM_IMG_BASE };
